import template from './user-children.html';
import userChildrenController from './user-children.controller';
import './user-children.styl';

let userChildrenComponent = {
  restrict: 'E',
  bindings: {
    children: '<'
  },
  template,
  controller: userChildrenController,
  controllerAs: 'vm'
};

export default userChildrenComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-children/user-children.component.js
 **/